import { FETCH_WEB_CONFIG } from "../../constants/webconfig";
import { feeds } from "../../apis/services";

export const getWEBConfig = () => ({
  type: FETCH_WEB_CONFIG,
  payload: feeds.getWEBConfig(),
});
